<template>
   <div> 
        <div class="header">
            <div class="container header-container">
                <div class="col-lg-8 header-img-section">
                    <img src="../assets/images/hero-illustration-v2.svg">
                </div>
                <div class="col-lg-4 header-title-section">
                    <p class="header-subtitle">Deel leuke momenten.</p>
                    <h1 class="header-title">Communiceren, verbondenheid.</h1>
                    <!-- <p class="header-title-text">Met de Family Portal App is zorg verlenen een plezier. Door meer verbondenheid worden inspanningen van iedereen zichtbaar en is er overzicht op de zorgverlening.</p> -->
                    <p class="header-title-text">De Family Portal App zorgt voor gelukkigere WZC-bewoners. Wij zijn de schakel tussen de bewoner, zijn omgeving en het WZC. Zorg verlenen wordt een plezier!.</p>
                </div>
            </div>
        </div>
        <!-- STRATEGY SECTION -->
        <div class="strategy-section">
            <div class="strategy-section-bg-graphics-section">
                <img src="../assets/images/strategy-section-bg.png">
            </div>
            <div class="container strategy-container">
                <div class="col-lg-3 col-md-6 col-xs-8 offset-xs-2 strategy-card-section">
                    <div class="strategy-card">
                        <div class="strategy-card-icon-section">
                            <img src="../assets/images/icon1.svg">
                        </div>
                        <!-- <h2>Deel Foto's & Info</h2> -->
                        <p style="margin-top: 14px;">Deel foto's, video's en (spraak-)berichten!</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-xs-8 offset-xs-2 strategy-card-section">
                    <div class="strategy-card">
                        <div class="strategy-card-icon-section">
                            <img src="../assets/images/icon2.svg">
                        </div>
                        <!-- <h2>Op TV of via Krantje</h2> -->
                        <p style="margin-top: 14px;">Op de televisie of in een papieren krantje.</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-xs-8 offset-xs-2 strategy-card-section">
                    <div class="strategy-card">
                        <div class="strategy-card-icon-section">
                            <img src="../assets/images/icon3.svg">
                        </div>
                        <!-- <h2>Zorginstelling</h2> -->
                        <p style="margin-top: 14px;">Deel interessante info vanuit de zorginstelling.</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-xs-8 offset-xs-2 strategy-card-section">
                    <div class="strategy-card">
                        <div class="strategy-card-icon-section">
                            <img src="../assets/images/icon4.svg">
                        </div>
                        <!-- <h2>Ondersteuning</h2> -->
                        <p style="margin-top: 14px;">Versterkt het vertrouwen in de organisatie.</p>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>